import { render, staticRenderFns } from "./CeremonyEventDetails.vue?vue&type=template&id=cb2097fa&scoped=true"
import script from "./CeremonyEventDetails.vue?vue&type=script&lang=js"
export * from "./CeremonyEventDetails.vue?vue&type=script&lang=js"
import style0 from "./CeremonyEventDetails.vue?vue&type=style&index=0&id=cb2097fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2097fa",
  null
  
)

export default component.exports